module.exports = __webpack_public_path__ + "img/提示@2x.8562c1b7.png";